function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SetPasswordForm } from './components/set-password-by-logged-in';
import { ChangePasswordForm } from './components/change-password';
export const ProfilePasswordComponent = props => {
  const {
    isPasswordNotSet,
    onSetSubmit,
    onChangeSubmit
  } = props;
  if (isPasswordNotSet) {
    return /*#__PURE__*/React.createElement(SetPasswordForm, _extends({}, props, {
      onSubmit: onSetSubmit
    }));
  }
  return /*#__PURE__*/React.createElement(ChangePasswordForm, _extends({}, props, {
    onSubmit: onChangeSubmit
  }));
};